import {AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors} from '@angular/forms';
import {calendarDaysBetween} from './date-utils';

export type TypedForm<T> = FormGroup<{
    [P in keyof T]: T[P] extends Array<string | number | boolean | bigint>
        ? FormControl<T[P]>
        : T[P] extends any[]
            ? FormArray<TypedForm<T[P][number]>>
            : T[P] extends object
                ? T[P] extends Date
                    ? FormControl<T[P]>
                    : TypedForm<T[P]>
                : FormControl<T[P]>;
}>;

export function maxDateDifferenceValidator(
    startDateKey: string,
    endDateKey: string,
    maxDays: number,
) {
    return (control: AbstractControl): ValidationErrors | null => {
        const startDate = control.get(startDateKey)?.value;
        const endDate = control.get(endDateKey)?.value;

        if (startDate && endDate && calendarDaysBetween(startDate, endDate) > maxDays) {
            return {maxDateDifference: true};
        }

        return null;
    };
}
